import { createFeature, createReducer } from '@ngrx/store';

import { jobCreateCustomerReducers } from './job-create-customer.reducer';
import { jobCreateCustomerInitialState } from './job-create-customer.state';

export const jobCreateCustomerFeature = createFeature({
  name: 'jobV3CreateCustomer',
  reducer: createReducer(jobCreateCustomerInitialState, ...jobCreateCustomerReducers),
});
